<template>
  <div :class="['page-document-library', isAdmin ? 'doclib-admin' : 'doclib-user']" style="min-height: 100%;">
  <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">Document Library</h1>
    <b-row style="min-height: 100%">
      <b-col lg="4" md="5" style="min-height: 800px; border-right: 1px solid #ccc;">
        <vue-tree-list
          @click="onClick"
          @change-name="onChangeName"
          @delete-node="onDel"
          @add-node="onAddNode"
          @drop="onDragDrop"
          @drop-before="onDragDrop"
          @drop-after="onDragDrop"
          :model="treeData"
          default-tree-node-name="New Folder"
          v-bind:default-expanded="false"
        >
          <template v-slot:leafNameDisplay="slotProps">
            <span :class="`folder${slotProps.model.id === currentFolder.id ? '-selected' : ''}`" :id="`folder-${slotProps.model.id}`" @drop="docDrop" @dragover="docAllowDrop">
              {{ slotProps.model.name }}
            </span>
          </template>
          <span class="icon" slot="addTreeNodeIcon" style="margin-right: 6px;"><b-icon-folder-plus /></span>
          <span class="icon" slot="editNodeIcon" style="margin-right: 6px;"><b-icon-cursor-text /></span>
          <span class="icon" slot="delNodeIcon" style="margin-right: 6px;"><b-icon-trash /></span>
          <span class="icon" slot="treeNodeIcon"><b-icon-folder style="margin-right: 6px" />&nbsp;</span>

          <span class="icon" slot="leafNodeIcon"></span>
          <span class="icon" slot="addLeafNodeIcon" style="margin-right: 6px;"></span>

        </vue-tree-list>
        <pre style="display: none;margin-top: 100px;">{{ newTree }}</pre>
      </b-col>

      <b-col lg="8" md="7">
        <b-btn class="hide-from-user" v-if="folderChanges || fileChanges" variant="success" @click="saveChanges" style="position:relative; top: -50px; float: right; margin-left: 10px;">Save Changes</b-btn>
        <b-btn class="hide-from-user" v-if="currentFolder.name" variant="secondary" @click="editingFolder=!editingFolder" style="position:relative; top: -50px; float: right; margin-left: 10px;">Edit Folder</b-btn>
        <b-btn class="hide-from-user" v-if="currentFolder.name && !editingFolder" variant="primary" @click="addingFile=!addingFile" style="position:relative; top: -50px; float: right; margin-left: 10px;">Add File</b-btn>
        <b-row v-if="addingFile" style="clear: both;">
          <b-col>
            <b-form>
              <b-card v-if="!newFileUrl" bg-variant="light" class="mb-3" header="Upload File">
                <b-form-group
                  label-cols-sm="2"
                  label="File:"
                  label-align-sm="right"
                >
                  <input type="file" class="hide-me-seymour" ref="fileupload" @change="fileChange($event)" />
                </b-form-group>
              </b-card>
              <b-card v-else bg-variant="light" class="mb-3" header="File Info">
                <b-form-group
                  label-cols-sm="3"
                  label="Name:"
                  label-align-sm="right"
                >
                  <b-form-input v-model="addingFileInfo.name" required @change="fileChanges=true"></b-form-input>
                </b-form-group>
                <!-- <b-form-group
                    label-cols-sm="3"
                    label="Keywords"
                    label-align-sm="right"
                  >
                  <b-form-input v-model="addingFileInfo.keywords" @change="fileChanges=true"></b-form-input>
                </b-form-group> -->
                <b-form-group
                    label-cols-sm="3"
                    label="Thumbnail"
                    label-align-sm="right"
                  >
                  <div class="thumbnail" :style="`background-image: url(${newFileUrl || '/img/file.png'});`"></div>
                </b-form-group>
                <b-btn variant="success" @click="addImageToFolder()" style="position:relative; float: right; margin-left: 10px;">Add File to Folder</b-btn>
              </b-card>
            </b-form>
          </b-col>
        </b-row>
        <b-row v-if="editingFile" style="clear: both;">
          <b-col>
            <b-form>
              <b-card bg-variant="light" class="mb-3" header="Edit File">
                <b-form-group
                  label-cols-sm="3"
                  label="Name:"
                  label-align-sm="right"
                >
                  <b-form-input v-model="editingFile.name" required @change="fileChanges=true"></b-form-input>
                </b-form-group>
                <b-form-group
                    label-cols-sm="3"
                    label="Thumbnail"
                    label-align-sm="right"
                  >
                  <div class="thumbnail" :style="`background-image: url(${editingFile.thumbnail || '/img/file.png'});`"></div>
                </b-form-group>
                <b-btn variant="success" @click="updateFile()" style="position:relative; float: right; margin-left: 10px;">Update File</b-btn>
              </b-card>
            </b-form>
          </b-col>
        </b-row>
        <b-row v-if="editingFolder" style="clear: both;">
          <b-col>
            <b-form v-if="editingFolder">
              <b-card bg-variant="light" class="mb-3" header="Edit Folder">
                <b-form-group
                  label-cols-sm="3"
                  label="Name:"
                  label-align-sm="right"
                >
                  <b-form-input v-model="currentFolder.name" required @change="changeFolderName"></b-form-input>
                </b-form-group>
                <b-form-group
                    label-cols-sm="3"
                    label="Required Badges"
                    label-align-sm="right"
                    description="If blank, any logged in user can acces. Otherwise, a user must have one or more of the selected badges to see this folder."
                  >
                  <multiselect v-model="currentFolder.badges" :multiple="true"
                    :custom-label="customLabel" :show-labels="false"
                    :options="badges" @input="changeBadges"></multiselect>
                </b-form-group>
              </b-card>
            </b-form>
          </b-col>
        </b-row>
        <b-row v-else-if="currentFolder.name" style="clear: both;">
          <b-col>
            <b-table striped hover :items="items" :fields="fields">
              <template #cell(name)="data">
                <div class="thumbnail" :style="`display: inline-block; float: left; background-image: url(${data.item.thumbnail});`"></div>
                <a style="padding-left: 20px; display: inherit; padding-top: 20px;" :href="`${getServerUrl()}/api/tools/file/${data.item.id}`">{{ data.value }}</a>
              </template>
              <template #cell(size)="data">
                {{ prettyBytes(data.value) }}
              </template>
              <template #cell(actions)="data">
                <a :id="`doc-move-${data.item.id}`" href="#" draggable="true" @dragstart="docDrag($event, data.item)"><b-icon-arrows-move /></a>
                <a href="#" @click="editingFile = data.item" style="margin-left: 10px;"><b-icon-wrench /></a>
                <a href="#" @click="tryDeleteFile(data.item.id)" style="margin-left: 10px;"><b-icon-trash /></a>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable max-len */
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';
import PrettyBytes from 'pretty-bytes';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

const acceptableThumbs = ['PNG', 'JPG', 'BMP', 'TIF', 'TIFF'];
const getThumb = (fileType, path) => {
  if (acceptableThumbs.includes(fileType)) {
    return `https://s3-us-west-1.amazonaws.com/arvc.org${path}`;
  } else {
    return '/img/file.png';
  }
};

export default {
  name: 'DocumentLibrary',
  components: {
    VueTreeList,
    Multiselect,
  },
  data() {
    return {
      loading: true,
      isAdmin: false,
      test: 'test',
      folderChanges: false,
      fileChanges: false,
      newFileUrl: null,
      newTree: {},
      currentFolder: {},
      editingFolder: false,
      addingFile: false,
      editingFile: null,
      draggingFile: null,
      addingFileInfo: {},
      addingFileThumbnail: '',
      badges: [],
      treeData: new Tree([]),
      fields: [
        {
          key: 'name',
          sortable: true,
        },
        {
          key: 'type',
          sortable: true,
        },
        'actions',
      ],
      items: [],
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawContact = await axios.get(`${server}/api/contact`);
        if (rawContact.data.redirect) {
          window.location.href = rawContact.data.redirect;
          return;
        }
        const rawBadges = await axios.get(`${server}/api/badges`);
        console.log('Loading contact', rawContact.data, rawBadges.data);
        this.badges = rawBadges.data;
        this.isAdmin = rawContact.data.OrderApi__Badges__c.includes('ARVC Staff');

        const rawFolders = await axios.get(`${server}/api/tools/documentlibrary`);
        this.treeData = new Tree(rawFolders.data.map((f) => this.checkIsAdmin(f)));

        this.loading = false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      } catch (err) {
        console.log({ docLibLoadError: err });
      }
    });
  },
  methods: {
    docAllowDrop(ev) {
      ev.preventDefault();
    },
    docDrag(ev, item) {
      console.log(`dragging ${ev.target.id}`);
      this.draggingFile = item;
      console.log({ dr: this.draggingFile });
      ev.dataTransfer.setData('text', ev.target.id);
    },
    async docDrop(ev) {
      ev.preventDefault();
      const data = ev.dataTransfer.getData('text');
      console.log(`dropping ${data} on ${ev.target.id}`);
      this.fileChanges = true;
      this.editingFile = this.draggingFile;
      this.editingFile.folderId = ev.target.id.split('-')[1];
      await this.updateFile();
      ev.target.click();
    },
    customLabel(item) {
      return item;
    },
    changeBadges(newValues) {
      console.log('Changed badges ', this.currentFolder, newValues);
      const n = this.findNode(this.currentFolder.id, this.treeData);
      n.badges = newValues;
      this.folderChanges = true;
    },
    changeFolderName(newValue) {
      console.log('Changed foldner name ', this.currentFolder, newValue);
      const n = this.findNode(this.currentFolder.id, this.treeData);
      n.name = newValue;
      this.folderChanges = true;
    },
    async fileChange(evt) {
      console.log({ files: evt.target.files[0] });
      const formData = new FormData();
      formData.append('file', evt.target.files[0]);
      const imageMeta = await axios.post(`${server}/api/tools/file/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      this.newFileUrl = imageMeta.data.url;
    },
    findNode(id, currentNode) {
      let i;
      let currentChild;
      let result;

      console.log({ id, currentNode });

      if (id === currentNode.id) {
        return currentNode;
      } else {
        if (currentNode.children && currentNode.children.length > 0) {
          for (i = 0; i < currentNode.children.length; i += 1) {
            currentChild = currentNode.children[i];
            result = this.findNode(id, currentChild);
            if (result !== false) {
              return result;
            }
          }
        }
        return false;
      }
    },
    checkIsAdmin(folder) {
      folder.dragDisabled = !this.isAdmin;
      folder.addLeafNodeDisabled = !this.isAdmin;
      folder.addTreeNodeDisabled = !this.isAdmin;
      folder.editNodeDisabled = !this.isAdmin;
      folder.delNodeDisabled = !this.isAdmin;
      if (folder.children && Array.isArray(folder.children)) {
        folder.children = folder.children.map((f) => this.checkIsAdmin(f));
      }
      return folder;
    },
    prettyBytes(bytes = 0) {
      return PrettyBytes(bytes);
    },

    getServerUrl() {
      return server;
    },

    onDel(node) {
      console.log(node);
      node.remove();
      this.folderChanges = true;
    },

    onChangeName(params) {
      console.log(params);
      if (params.oldName !== params.newName) {
        this.folderChanges = true;
      }
    },

    onDragDrop(params) {
      console.log(params);
      this.folderChanges = true;
    },

    onAddNode(params) {
      console.log(params);
      this.folderChanges = true;
    },

    onClick(params) {
      console.log('Opening', params);
      this.currentFolder = params;
      this.loadFiles(this.currentFolder);
    },

    async loadFiles(params) {
      console.log('Loading files for ', params);

      try {
        const rawDoc = await axios.get(`${server}/api/tools/documentlibrary/${params.id}`);
        if (rawDoc.data && rawDoc.data.length > 0) {
          this.items = rawDoc.data.map((d) => {
            const sepPath = d.path.split('.');
            const fileType = sepPath[sepPath.length - 1].toUpperCase();
            return {
              isActive: true,
              id: d.id,
              size: 0,
              name: d.title,
              type: fileType,
              thumbnail: getThumb(fileType, d.path),
            };
          });
        } else {
          this.items = [];
        }
      } catch (err) {
        console.log({ docLibLoadError: err });
      }
    },

    addNode() {
      const node = new TreeNode({ name: 'New Folder', isLeaf: false });
      if (!this.data.children) this.data.children = [];
      this.data.addChildren(node);
    },

    getNewTree() {
      const vm = this;
      function _dfs(oldNode) {
        const newNode = {};

        for (const k in oldNode) {
          if (k !== 'children' && k !== 'parent') {
            newNode[k] = oldNode[k];
          }
        }

        if (oldNode.children && oldNode.children.length > 0) {
          newNode.children = [];
          for (let i = 0, len = oldNode.children.length; i < len; i++) {
            newNode.children.push(_dfs(oldNode.children[i]));
          }
        }
        return newNode;
      }

      vm.newTree = _dfs(vm.treeData);
      return vm.newTree;
    },

    async updateFile() {
      if (this.fileChanges) {
        console.log('Has file changes', this.editingFile);
        try {
          const saveResult = await axios.post(`${server}/api/tools/documentlibrary/editfile`, { file: this.editingFile });
          console.log({ saveResult });
          this.editingFile = null;
          this.fileChanges = false;
        } catch (err) {
          console.log({ docLibUpdateFileError: err });
        }
        this.folderChanges = false;
      }
    },

    async saveChanges() {
      if (this.folderChanges) {
        console.log('Has folder changes');
        const tree = this.getNewTree();
        console.log('Saving folders', JSON.stringify(tree.children, null, 2));
        try {
          const saveResult = await axios.post(`${server}/api/tools/documentlibrary/folders`, { folders: JSON.stringify(tree.children) });
          console.log({ saveResult });
        } catch (err) {
          console.log({ docLibLoadError: err });
        }
        this.folderChanges = false;
      }
      if (this.fileChanges) {
        console.log('Saving files');
        this.fileChanges = false;
      }
    },

    showFileInfo(file) {
      console.log({ file });
      this.addingFileInfo.displayName = this.addingFileInfo.name.substr(0, this.addingFileInfo.name.lastIndexOf('.'));
      console.log(this.addingFileInfo);
      this.addingFileThumbnail = URL.createObjectURL(this.addingFileInfo);
      console.log(this.addingFileThumbnail);
      this.addingFileThumbnail = URL.createObjectURL(file);
      console.log(this.addingFileThumbnail);
    },

    async addImageToFolder() {
      const typeSplit = this.newFileUrl.split('.');
      const type = typeSplit[typeSplit.length - 1];

      try {
        const saveResult = await axios.post(`${server}/api/tools/file/new`, {
          folderId: this.currentFolder.id,
          title: this.addingFileInfo.name,
          fileUrl: this.newFileUrl,
        });
        console.log({ saveResult });
        this.items.push(
          {
            isActive: true,
            id: saveResult.data.insertId,
            name: this.addingFileInfo.name,
            type,
            thumbnail: this.newFileUrl,
          },
        );
        this.addingFileThumbnail = null;
        this.addingFileInfo = {};
        this.addingFile = false;
      } catch (err) {
        console.log({ docLibAddError: err });
      }
    },

    upload() {
      this.$refs.fileupload.click();
    },

    tryDeleteFile(id) {
      this.$bvModal.msgBoxConfirm('Are you sure you wish delete this file? You will no longer be able to access this file.', {
        title: 'Delete File',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes, Delete',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then(async (value) => {
          if (value === true) {
            try {
              console.log('deleting file', id);

              try {
                const saveResult = await axios.delete(`${server}/api/tools/file/${id}`);
                console.log({ saveResult });
              } catch (err) {
                console.log({ docLibLoadError: err });
              }

              // /api/tools/file/id
              this.items = this.items.filter((x) => x.id !== id);
            } catch (err) {
              console.err(err);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">

.page-document-library {
  .vtl {
    .vtl-drag-disabled {
      cursor: pointer;
    }
    .vtl-tree-margin {
      margin-left: 1em;
    }
  }

  .icon {
    &:hover {
      cursor: pointer;
    }
  }

  .muted {
    color: gray;
    font-size: 80%;
  }

  .folder-selected {
    font-weight: bold;
  }

  .row .table th, .row .table td {
    vertical-align: middle !important;
  }

  .table img {
    margin-right: 10px;
  }

  .thumbnail {
    width: 96px;
    height: 96px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    border: 1px solid #ddd;
    border-radius: 8px;
  }
}

.doclib-user {
  .vtl-operation, .hide-from-user, th:last-child, td:last-child {
    display: none;
  }
}
</style>
